<template>
  <div class="app-container">
    <NavTitle :title="title" />

    <div class="code-search-box">
      <div class="code-search-input">
        <div class="code-search-input-label">追溯码</div>
        <el-input
          v-model="barcode"
          placeholder="请输入追溯码进行查询"
          size="mini"
          style="width: 100%"
          @keyup.enter.native="handleSearch"
        ></el-input>
      </div>
      <div class="code-search-button">
        <el-button type="primary" size="mini" @click="handleSearch"
          >查询</el-button
        >
        <el-button plain size="mini" @click="handleReset">重置</el-button>
      </div>
    </div>

    <div class="code-body-box">
      <div class="code-body-item" v-loading="loading">
        <div class="code-body-item-title">关联关系</div>
        <div class="code-body-item-association">
          <div v-for="(v, i) in barcodes" :key="i">
            <Association
              :item="v"
              :level="0"
              @handleClick="handleClickAssociation"
            />
          </div>
        </div>
      </div>
      <div class="code-body-item" v-loading="loading">
        <div class="code-body-item-title">药品信息</div>
        <div class="code-body-item-info">
          <div
            class="code-body-item-info-item"
            v-for="(v, i) in drugInfos"
            :key="i"
          >
            <div class="code-body-item-info-item-label">{{ v.title }}</div>
            ：
            <EllipsisTooltip
              :content="v.value"
              class="code-body-item-info-item-value"
              v-if="v.value !== ''"
            >
              {{ v.value }}
            </EllipsisTooltip>
            <div class="code-body-item-info-item-tag" v-if="v.attachText">
              <div>{{ v.attachText }}</div>
            </div>
            <div
              class="code-body-item-info-item-tag active"
              @click="handleClickTag(v)"
              v-if="v.isException"
            >
              <div>异常</div>
              <i class="el-icon-arrow-right" />
            </div>
          </div>
        </div>
      </div>
      <div class="code-body-item" v-loading="loading">
        <div class="code-body-item-title">医保信息</div>
        <div
          class="code-body-item-medical"
          v-for="(v, i) in categorys"
          :key="i"
        >
          <div class="code-body-item-medical-label">{{ v.title }}</div>
          ：
          <EllipsisTooltip
            :content="v.value"
            class="code-body-item-medical-value"
          >
            {{ v.value }}
          </EllipsisTooltip>
        </div>
      </div>
    </div>

    <div class="code-table-box">
      <div class="code-table-title">单据信息</div>
      <el-table
        ref="workTableRef"
        :data="tableList"
        stripe
        :header-cell-style="{
          background: '#F0F3F7',
          color: '#2a354e',
          fontWeight: 400,
        }"
        style="width: 98%; margin: 0 auto"
        height="280"
        highlight-current-row
        :row-key="'id'"
        @row-click="handleRowClick"
        v-loading="loading"
        size="mini"
      >
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.disabled" style="color: #606266"
              >查看详情</span
            >
            <span
              v-else
              style="color: #4076f2; cursor: pointer"
              @click="handleDetail(scope.row)"
              >查看详情</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="单据编号"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="orderClassName"
          label="单据类型"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="orderDate"
          label="单据日期"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="table-lable">
              {{ scope.row.orderDate }}
            </div>
            <div class="table-value">
              {{ scope.row.orderRecDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shippedEnterpriseName"
          label="发货机构"
          width="250"
        >
          <template slot-scope="scope">
            <div class="table-lable">
              {{ scope.row.shippedEnterpriseName }}
            </div>
            <div class="table-value">
              {{ scope.row.shippedEnterpriseLocation }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shippedEnterpriseTypeStr"
          label="机构类型"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="receivedEnterpriseName"
          label="收货机构"
          width="250"
        >
          <template slot-scope="scope">
            <div class="table-lable">
              {{ scope.row.receivedEnterpriseName }}
            </div>
            <div class="table-value">
              {{ scope.row.receivedEnterpriseLocation }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="receivedEnterpriseTypeStr"
          label="机构类型"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="trustedEnterpriseName"
          label="储运机构"
          width="250"
        >
          <template slot-scope="scope">
            <div class="table-lable">
              {{ scope.row.trustedEnterpriseName }}
            </div>
            <div class="table-value">
              {{ scope.row.trustedEnterpriseLocation }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="trustedEnterpriseTypeStr"
          label="机构类型"
          :show-overflow-tooltip="true"
        />
      </el-table>
    </div>

    <TipDialog ref="TipDialogRef" />
    <OrderDetail ref="OrderDetailRef" />
  </div>
</template>

<script>
import Association from "./components/association.vue";
import EllipsisTooltip from "@/components/EllipsisTooltip/index.vue";
import TipDialog from "@/components/TipDialog/index.vue";
import OrderDetail from "@/components/OrderDetail/index.vue";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "CodeSearch",
  components: {
    Association,
    EllipsisTooltip,
    TipDialog,
    OrderDetail,
    NavTitle,
  },
  data() {
    return {
      title: ["追溯码查询"],
      barcode: "",
      tableList: [],
      barcodes: [],
      categorys: [],
      drugInfos: [],
      selectedRow: null,
      loading: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleClickAssociation(row) {
      this.barcode = row.barcodeNoPlus;
    },
    handleClickTag(row) {
      this.$refs.TipDialogRef.show({
        title: row.innerTitle,
        content: row.innerMsg,
      });
    },
    handleDetail(row) {
      this.$refs.OrderDetailRef.show(row);
    },
    async handleSearch() {
      if (!this.barcode) {
        this.tableList = [];
        this.barcodes = [];
        this.categorys = [];
        this.drugInfos = [];
        return;
      }
      this.loading = true;
      const { data } = await this.$api.flow.GetBarcodeOrderFlows({
        barcode: this.barcode,
      });
      this.loading = false;
      this.barcodes = data.barcodes;
      this.categorys = data.categorys;
      this.drugInfos = data.drugInfos;
      this.tableList = data.orders;
    },
    handleReset() {
      this.barcode = "";
    },
  },
};
</script>

<style scoped>
.table-lable {
  width: 100%;
  /* text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; */
}
.table-value {
  font-weight: 400;
  font-size: 11px;
  color: #92969f;
  width: 100%;
  /* text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; */
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
